import ClientTypesApi from '../../../core/api/ClientTypesApi'

export const events = {
  edit: {
    start: 'START_EDITING_CLIENT_TYPES',
    stop: 'STOP_EDITING_CLIENT_TYPES',
    cancel: 'CANCEL_EDITING_CLIENT_TYPES'
  },
  fetch: {
    fetched: 'ADVISER_CLIENT_TYPE_PREFERENCES_FETCHED_CLIENT_TYPES'
  },
  set: {
    selectionChanged: 'ADVISER_CLIENT_TYPE_PREFERENCES_CLIENT_TYPE_SELECTED_CHANGED'
  }
}

const clientTypesApi = new ClientTypesApi()

const { edit, fetch, set } = events
export const actions = {
  edit: {
    start: () => ({
      type: edit.start
    }),
    stop: () => ({
      type: edit.stop
    }),
    cancel: () => ({
      type: edit.cancel
    })
  },
  fetch: {
    clientTypes: () => {
      const request = clientTypesApi.fetchingClientTypes()

      return (dispatch) => {
        request.then(function (response) {
          dispatch(clientTypesApi.handleResponse(fetch.fetched, response))
        })
      }
    }
  },
  set: {
    selectionChanged: (clientType) => ({
      type: set.selectionChanged,
      clientType
    })
  }
}
